<template>
  <div class="container">
    <vs-card title="Modelos de Riesgo">
      <vs-table :data="versions" stripe>
        <template slot="thead">
          <vs-th>Id</vs-th>
          <vs-th>Nombre de la versión</vs-th>
          <vs-th>Opciones</vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr v-for="version in data">
            <vs-td>{{ version.id }}</vs-td>
            <vs-td>{{ version.name }}</vs-td>
            <vs-td style="width: 400px">
              <vs-button @click="$router.push('/risk-model/admin/' + version.id + '/editor')">Editar</vs-button>
              <vs-button class="ml-2" color="dark" @click="versionDuplicateDialog(version)">Duplicar</vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-card>

    <vs-popup title="Nueva versión" :active.sync="newVersionDialog">
      <vs-select
          v-model="newVersionForm.oldVersionId"
          label="Versión base"
          class="w-full"
      >
        <vs-select-item v-for="version in versions" :value="version.id" :text="version.name"></vs-select-item>
      </vs-select>

      <vs-input
          label="Nombre de la versión"
          v-model="newVersionForm.name"
          class="w-full mt-4"></vs-input>

      <vs-button
          class="mt-4"
          color="dark"
          @click="createNewVersion">Crear</vs-button>
    </vs-popup>

    <version-editor
      :active.sync="showDialog"
      :version="version"></version-editor>

  </div>
</template>

<script>
import VersionEditor from "@views/admin/RiskModel/Admin/VersionEditor";

export default {
  name: "Versions",
  components: {VersionEditor},
  data: () => ({
    versions: [],
    newVersionForm: {
      oldVersionId: null,
      name: null
    },
    version: {},
    showDialog: false,
    newVersionDialog: false
  }),
  async mounted() {
    let riskModelId = this.$route.params.riskModelId;
    let response = await axios.get("/api/risk-model/" + riskModelId + "/version")

    this.versions = response.data;
  },
  methods: {
    versionDuplicateDialog(version) {
      this.newVersionDialog = true;
      this.newVersionForm.oldVersionId = version.id;
    },
    versionEditorDialog(version) {
      this.showDialog = true;
      this.version = version;
    },
    async createNewVersion() {
      this.$vs.loading();
      try {
        const {data} = await axios.post("/api/risk-model/" + this.$route.params.riskModelId + "/version/duplicate", {
          name: this.newVersionForm.name,
          versionId: this.newVersionForm.oldVersionId
        });
        this.versions.push(data);
        this.newVersionDialog = false;
        this.$vs.loading.close();
      } catch (e) {
        this.$vs.loading.close();
      }
    }
  }
}
</script>

<style scoped>

</style>
